<template>
	<div class="Site IndexBox" style="padding-bottom: 0;">
	  <div class="ScrollBox">
		  <van-nav-bar
		      fixed
		      :border="false"
		      :title="$t('lucky.default[0]')"
		      left-arrow
		      @click-left="$router.go(-1)"
		  		  @click-right="$router.push('/luckyRecord')"
		  >
		  <template #right>
		      <div>
		  			  <van-icon name="clock-o" dot="" />
		      </div>
		    </template>
		  </van-nav-bar>
		  <div class="main-box">
			  
			  <p class="top" >{{ $t("lucky.scattered[0]") }} <label style="color: #feca83;">{{count}}</label> </p>
				  <div class="Sudoku">
					<div class="container-out">
						<div
						class="circle"
						v-for="(item,index) in circleList"
						:key="index"
						:style="{'top':(item.topCircle)/(100/3)+'rem','left':(item.leftCircle)/(100/3)+'rem','background-color':(index%2==0)?colorCircleFirst:colorCircleSecond}"
						></div>
					
						<div class="container-in">
						<div
							class="content-out"
							v-for="(item,index) in awardList"
							:key="index"
							:style="{top:(item.topAward)/(100/3.3)+'rem',left:(item.leftAward)/(100/3.3)+'rem','background-color': (index==indexSelect)?colorAwardSelect:colorAwardDefault}"
						>
							
							<img class="award-image" :src="item.bigImg" />
						</div>
						<div
							class="start-btn"
							@click="beginRotate"
							:style="{'background-color':isRunning?'#e7930a':'#ffe400'}"
						>{{ $t("lucky.scattered[1]") }}</div>
						</div>
					</div>
				  </div>

				  <div class="tip-box">
				    <div class="tip-header">
				      <van-icon name="info" class="tip-icon" />
				      <h3 class="tip-title">{{ $t("lucky.scattered[4]") }}</h3>
				    </div>
				    
				    <ul class="tip-list">
				      <li class="tip-item">
				        <van-icon name="certificate" class="item-icon" />
				        <div class="item-content">
				          <div class="item-title">{{ $t("lucky.scattered[5]") }}</div>
				          <p>{{ $t("lucky.scattered[6]") }}</p>
				        </div>
				      </li>
				      
				      <li class="tip-item">
				        <van-icon name="clock" class="item-icon" />
				        <div class="item-content">
				          <div class="item-title">{{ $t("lucky.scattered[7]") }}</div>
				          <p>{{ $t("lucky.scattered[8]") }}</p>
				        </div>
				      </li>
				      
				      <li class="tip-item">
				        <van-icon name="gift" class="item-icon" />
				        <div class="item-content">
				          <div class="item-title">{{ $t("lucky.scattered[9]") }}</div>
				          <p>{{ $t("lucky.scattered[10]") }}</p>
				        </div>
				      </li>
				    </ul>
				  </div>
				
				<div class="prize-pool">
				  <h3 class="pool-title">🎁 {{ $t("lucky.prizeList[0]") }}</h3>
				  <div class="prize-grid">
				    <div class="prize-item cash">
				      <div class="prize-icon">💰</div>
				      <div class="prize-content">
				        <div class="amount">{{ $t("lucky.prizeList[1]") }}</div>
				        <div class="label">{{ $t("lucky.prizeList[2]") }}</div>
				      </div>
				    </div>
					<div class="prize-item cash1">
					  <div class="prize-icon">💰</div>
					  <div class="prize-content">
					    <div class="amount">{{ $t("lucky.prizeList[3]") }}</div>
					    <div class="label">{{ $t("lucky.prizeList[2]") }}</div>
					  </div>
					</div>
					<div class="prize-item cash2">
					  <div class="prize-icon">💰</div>
					  <div class="prize-content">
					    <div class="amount">{{ $t("lucky.prizeList[4]") }}</div>
					    <div class="label">{{ $t("lucky.prizeList[2]") }}</div>
					  </div>
					</div>
					<div class="prize-item cash3">
					  <div class="prize-icon">💰</div>
					  <div class="prize-content">
					    <div class="amount">{{ $t("lucky.prizeList[5]") }}</div>
					    <div class="label">{{ $t("lucky.prizeList[2]") }}</div>
					  </div>
					</div>
					<div class="prize-item cash4">
					  <div class="prize-icon">💰</div>
					  <div class="prize-content">
					    <div class="amount">{{ $t("lucky.prizeList[6]") }}</div>
					    <div class="label">{{ $t("lucky.prizeList[2]") }}</div>
					  </div>
					</div>
				    <div class="prize-item device">
				      <div class="prize-icon">📱</div>
				      <div class="prize-content">
				        <div class="name">{{ $t("lucky.prizeList[7]") }}</div>
				        <div class="value">{{ $t("lucky.prizeList[8]") }}</div>
				      </div>
				    </div>
				    <!-- 其他奖项类似结构 -->
				    <div class="prize-item voucher1">
				      <div class="prize-icon">🎫</div>
				      <div class="prize-content">
				        <div class="name">{{ $t("lucky.prizeList[9]") }}</div>
				        <div class="value">{{ $t("lucky.prizeList[10]") }}</div>
				      </div>
				    </div>
					<div class="prize-item voucher2">
					  <div class="prize-icon">📦</div>
					  <div class="prize-content">
					    <div class="name">{{ $t("lucky.prizeList[11]") }}</div>
					    <div class="value">{{ $t("lucky.prizeList[12]") }}</div>
					  </div>
					</div>
					<div class="prize-item voucher3">
					  <div class="prize-icon">🔋</div>
					  <div class="prize-content">
					    <div class="name">{{ $t("lucky.prizeList[13]") }}</div>
					    <div class="value">{{ $t("lucky.prizeList[14]") }}</div>
					  </div>
					</div>
					<div class="prize-item vehicle">
					  <div class="prize-icon">🚲</div>
					  <div class="prize-content">
					    <div class="name">{{ $t("lucky.prizeList[15]") }}</div>
					    <div class="value">{{ $t("lucky.prizeList[16]") }}</div>
					  </div>
					</div>
				    <div class="prize-item vehicle1">
				      <div class="prize-icon">🛵</div>
				      <div class="prize-content">
				        <div class="name">{{ $t("lucky.prizeList[17]") }}</div>
				        <div class="value">{{ $t("lucky.prizeList[18]") }}</div>
				      </div>
				    </div>
					<div class="prize-item vehicle2">
					  <div class="prize-icon">📱</div>
					  <div class="prize-content">
					    <div class="name">{{ $t("lucky.prizeList[19]") }}</div>
					    <div class="value">{{ $t("lucky.prizeList[20]") }}</div>
					  </div>
					</div>
				  </div>
				</div>
				
				<van-swipe id="SwipeList1" style="height: 340px" height="68" vertical autoplay="3000" :show-indicators="false" :touchable="false">
				  <van-swipe-item v-for="(item,index) in winUser" :key="index" :index="index">
				    <van-cell
				      class="topItem" 
				      :icon="`./static/head/${item.header}`" 
				      :title="$t('lucky.default[6][0]',{member: item.username})"
				      :label="$t('lucky.default[6][1]',{profit:item.profit})"
				      center
				    >
				    </van-cell>
				  </van-swipe-item>
				</van-swipe>
				  
			  </div>
			  
		</div>
		

		<div class="toast" v-show="isShow">
			<div class="toast-container">
				<div class="close" @click="closeToast()"></div>
				<div class="toast-title">{{toastTitle}}</div>
				<img style="margin-top: 5px;" class="prize_picture" :src="prize_picture"/>
				<div class="toast-btn" style="margin-top: 10px;">
				  <div class="toast-cancel"  @click="closeToast">{{$t("lucky.default[8]")}}</div>
				</div>
			</div>
		</div>
		<!-- <div class="toast-mask" v-show="prize"></div> -->
		
  </div>
</template>
 
<script>
	import { Icon } from 'vant';
export default {
  name: "Sudoku",
  data() {
    return {
      circleList: [], //圆点数组
      awardList: [], //奖品数组   真正渲染的列表  把每个奖品的偏移量也存放在一起
      colorCircleFirst: "#FFDF2F", //圆点颜色1
      colorCircleSecond: "#FE4D32", //圆点颜色2
      colorAwardDefault: "#F5F0FC", //奖品默认颜色
      colorAwardSelect: "#ff0000", //奖品选中颜色
      indexSelect: 0, //被选中的奖品index
      isRunning: false, //是否正在抽奖
      angleList: [], //奖品图片数组
	  isClick:true,
	  count: 0, // 剩余抽奖次数
	  prize: null,
	  prize_picture:'',
	  isShow:false,
	  winUser:[],
	  jpid:0
	  
    };
  },
 
  components: {},
  created() {
	  // 初始化一些值
	  this.angleList = []
	  // 获取奖品列表
	  this.initPrizeList();
  },
 
  watch: {},
 
  mounted() {
  },
  computed:{
  	toastTitle () {
  	  return this.prize 
  	    ? this.$t('lucky.default[7]') +
  	        this.prize
  	    : "";
  	}
  },
 
  methods: {
	  //关闭弹窗
	  closeToast() {
	    this.isShow = false;
		this.isClick = true;
	  },
	initPrizeList() {
	  // 这里可以发起请求，从服务端获取奖品列表
	  // 这里使用模拟数据
	  this.$Model.getLuckyList((data) => {
		  this.luckyList = data.info.prizeList;
		  this.winUser = data.info.winUser;
		  this.count = data.info.draws_num;
		  this.prizeList = this.formatPrizeList(data.info.prizeList)
	  });
	  
	},
	// 格式化奖品列表，计算每个奖品的位置
	formatPrizeList (list) {
		
	  // 记录每个奖的位置
	  const angleList = []
	  list.forEach((item, i) => {
	    angleList.push(item)
	  })
	  this.angleList = angleList
	  this.draw();
	  return list
	},
    //画页面的原点以及每个奖品图片的位置
    draw() {
      var _this = this;
      //圆点设置的每一个位置的偏移量  总共24个原点
      var leftCircle = 7.5;
      var topCircle = 7.5;
      var circleList = [];
	  
      for (var i = 0; i < 24; i++) {
        if (i == 0) {
          topCircle = 15;
          leftCircle = 15;
        } else if (i < 6) {
          topCircle = 7.5;
          leftCircle = leftCircle + 102.5;
        } else if (i == 6) {
          topCircle = 15;
          leftCircle = 620;
        } else if (i < 12) {
          topCircle = topCircle + 94;
          leftCircle = 620;
        } else if (i == 12) {
          topCircle = 565;
          leftCircle = 620;
        } else if (i < 18) {
          topCircle = 570;
          leftCircle = leftCircle - 102.5;
        } else if (i == 18) {
          topCircle = 565;
          leftCircle = 15;
        } else if (i < 24) {
          topCircle = topCircle - 94;
          leftCircle = 7.5;
        } else {
          return;
        }
        circleList.push({ topCircle: topCircle, leftCircle: leftCircle });
      }
		
 //      _this.circleList = circleList; //原点
 
 //      //设置圆点闪烁
 //      setInterval(function() {
 //        if (_this.colorCircleFirst == "#FFDF2F") {
 //          _this.colorCircleFirst = "#FE4D32";
 //          _this.colorCircleSecond = "#FFDF2F";
 //        } else {
 //          _this.colorCircleFirst = "#FFDF2F";
 //          _this.colorCircleSecond = "#FE4D32";
 //        }
 //      }, 500); //设置圆点闪烁的效果
 
 
      //奖品item设置
      var awardList = [];
 
      //间距,怎么顺眼怎么设置吧.
      var topAward = 20;
      var leftAward = 30;
      for (var j = 0; j < _this.angleList.length; j++) {
        if (j == 0) {
          topAward = 20;
          leftAward = 30;
        } else if (j < 4) {
          topAward = topAward;
          //166.6666是宽.15是间距.下同
          leftAward = leftAward + 145 ;
        } else if (j < 7) {
          leftAward = leftAward;
          //150是高,15是间距,下同
          topAward = topAward + 135 ;
        } else if (j < 10) {
          leftAward = leftAward - 145 ;
          topAward = topAward;
        } else if (j < 13) {
          leftAward = leftAward;
          topAward = topAward - 135 ;
        }
 
        var angleList = _this.angleList[j];
		
        awardList.push({
          topAward: topAward,
          leftAward: leftAward,
          name: angleList.name,
          id: angleList.id,
		  bigImg:angleList.icon,
		  caption:angleList.name,
        });
		
      }
		console.log(awardList)
      _this.awardList = awardList;
    },
	
	beginRotate() {
	  // 添加次数校验
	  if(this.count === 0) {
		  this.$Dialog.Alert(this.$t('lucky.default[9]'))
		   return
	  }
	  
	  // 正在选择旋转 就请求不了
	  if (this.isClick) {
		  this.isClick = false;
		  // 开始抽奖
		  // 这里这里向服务端发起请求，得到要获得的奖
		  // 可以返回下标，也可以返回奖品 id，通过查询 奖品列表，最终得到下标
		  this.$Model.luckyPro((data)=>{
		  	if (data.code == 1) {
		  		this.index = data.prize - 1;
				this.jpid = data.prize;
		  		// 减少剩余抽奖次数
		  		this.count--
		  		// 开始旋转
		  		this.startGame()
		  	} else {
		  		this.$Dialog.Alert(data.msg)
		  	}
		  	
		  });
	  }
	},
 
    //开始抽奖
    startGame: function() {
      if (this.isRunning) return;
 
      this.isRunning = true; //点击
      var _this = this;
	  let select = _this.index;
      var indexSelect = 0; //默认从0开始
      var i = 10; //控制速度的
 
      var timer = setInterval(function() {
        indexSelect++;
        //这里我只是简单粗暴用y=30*x+200函数做的处理.可根据自己的需求改变转盘速度
        i += 40;
       	indexSelect = indexSelect % (_this.angleList.length);
        _this.indexSelect = indexSelect;
		
        //固定下标停止,当满足转动时间并且奖品下标是3的时候停止定时器
        if (i > 1000 && _this.awardList[indexSelect].id == _this.jpid) {
			//去除循环
			clearInterval(timer);
			_this.isRunning = false;
			_this.prize=_this.awardList[indexSelect].caption ;
			_this.prize_picture = _this.awardList[indexSelect].bigImg;
			// console.log(_this.awardList[indexSelect])
			_this.isShow=true
        }
      }, 200 + i);
    }
  },
 

};
</script>
 
 
<style  scoped>
/deep/ .van-nav-bar__title{color:#fff}
.ScrollBox{
	background-image: url("../assets/img/bg.png");
	background-repeat: no-repeat;
	background-size: 100% 100%;
}
.main-box {
    padding: 0;
    margin: 3rem auto;
    width: 360px;
}
.main-box .top {
    margin: 8px 0 0 0;
    font-size: 14px;
    font-weight: 600;
}
.main-box .top {
    margin: 8px 0 0 0;
    font-size: 14px;
    font-weight: 600;
}
.main-box .top>img {
    width: 250px;
}
.main-box .logo {
    background-image: url("../assets/img/lottery_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 360px;
    height: 238px;
    display: flex;
    align-items: center;
	margin-top: 50px;
}
.main-box .logo img {
    width: 134px;
    margin: 0 auto;
}
.tip {
	text-align: center;
}
.tip>* {
    margin: 0;
}
.tip h4 {
    font-size: 22px;
    font-weight: 700;
    background: linear-gradient(171deg,#61f2ff,#5243ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.lottery-box {
    margin: 0 auto;
    margin-top: 22px;
    padding-bottom: 22px;
}


.container-out {
  height: 18rem;
  width: 21rem;
  background-color: #f2f3e1;
  margin: 1.2rem auto;
  border-radius: .4rem;
  box-shadow: 0 0.1px 0 #f2f3e1;
  position: relative;
}
 
.container-in {
  width: 21rem;
  height: 20rem;
  background-color: #55aa00;
  border-radius: .4rem;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
 
/**小圆球
box-shadow: inset 3px 3px 3px #fff2af;*/
.circle {
  position: absolute;
  display: block;
  border-radius: 50%;
  height: 0.6rem;
  width: 0.6rem;
}
 
.content-out {
  position: absolute;
  height: 4.5rem;
  width: 5rem;
  background-color: #f5f0fc;
  border-radius: 0.45rem;
  box-shadow: 0 0.05px 0 #d87fde;
}
 
/**居中 加粗*/
 
.start-btn {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 4.5rem;
  width: 5rem;
  background-color: #ffe400;
  box-shadow: 0 0.15px 0 #e7930a;
  color: #f6251e;
  text-align: center;
  font-size: 1.2rem;
  font-weight: bolder;
  line-height: 4.5rem;
}
 
.award-image {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 4rem;
  width: 3.6rem;
}


.Site .van-cell{
	/* background-color */
	background-color: rgba(255, 255, 255, 0.3);
	color: #807f91;
}

	.toast {
	  position: fixed;
	  top: 50%;
	  left: 50%;
	  z-index: 20000;
	  transform: translate(-50%, -50%);
	  width: 15.4375rem;
	  background: #fff;
	  border-radius: 0.3125rem;
	  padding: 0.3125rem;
	  background-color: rgb(49, 108, 48) ;
	  background-image: linear-gradient(45deg,#00a14e,#4cd027,#10ff0c);
	}
	
	.toast-container {
	  position: relative;
	  width: 100%;
	  height: 100%;
	  /* border: 1px dotted #fccc6e; */
	}
	.toast-picture {
	  position: absolute;
	  top: -6.5rem;
	  left: -1.5rem;
	  width: 18.75rem;
	  height: 8.5625rem;
	}
	.toast-pictrue-change {
	  position: absolute;
	  top: -1.5rem;
	  left: -1.375rem;
	  width: 17.5rem;
	  height: 3.125rem;
	}
	.toast-title {
	  padding: 2.8125rem 0 0 0 ;
	  font-size: 18px;
	  color: #000000;
	  text-align: center;
	}
	.prize_picture{
		width: 50%;
		/* height: 45%; */
		margin-left: 25%;
	}
	.toast-btn {
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  margin-bottom: 0.9375rem;
	}
	.toast-btn div {
	  background-image: -moz-linear-gradient(
	    -18deg,
	    rgb(85, 170, 0) 0%,
	    rgb(85, 170, 0) 51%,
	    rgb(85, 170, 0) 99%
	  );
	
	  background-image: -ms-linear-gradient(
	    -18deg,
	    rgb(0, 170, 0) 0%,
	    rgb(0, 170, 0) 51%,
	    rgb(0, 170, 0) 99%
	  );
	  background-image: -webkit-linear-gradient(
	    -18deg,
	    rgb(0, 170, 0) 0%,
	    rgb(0, 170, 0) 51%,
	    rgb(0, 170, 0) 99%
	  );
	  /* box-shadow: 0px 4px 0px 0px rgba(174, 34, 5, 0.7); */
	  width: 4.6875rem;
	  height: 1.875rem;
	  border-radius: 1.875rem;
	  text-align: center;
	  line-height: 1.875rem;
	  color: #fff;
	}
	.close {
	  position: absolute;
	  top: -0.9375rem;
	  right: -0.9375rem;
	  width: 2rem;
	  height: 2rem;
	  background: url("../assets/img/close_store.png") no-repeat center top;
	  background-size: 100%;
	}
	
	
	/* 说明 */
	.prize-pool {
	  background: rgba(255, 255, 255, 0.1);
	  border-radius: 15px;
	  padding: 20px;
	  margin: 20px 0;
	  backdrop-filter: blur(5px);
	  border: 1px solid rgba(255, 255, 255, 0.2);
	}
	
	.pool-title {
	  color: #ff0000;
	  text-align: center;
	  font-size: 1.5em;
	  margin-bottom: 1.5em;
	  text-shadow: 0 2px 4px rgba(0,0,0,0.2);
	}
	
	.prize-grid {
	  display: grid;
	  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
	  gap: 15px;
	}
	
	.prize-item {
	  background: linear-gradient(145deg, rgba(255,255,255,0.15), rgba(255,255,255,0.05));
	  border-radius: 10px;
	  padding: 15px;
	  display: flex;
	  align-items: center;
	  transition: transform 0.3s ease;
	}
	
	.prize-item:hover {
	  transform: translateY(-3px);
	}
	
	.prize-icon {
	  font-size: 2em;
	  margin-right: 15px;
	  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.2));
	}
	
	.prize-content {
	  flex: 1;
	}
	
	.amount, .name {
	  color: #00557f;
	  font-weight: 600;
	  font-size: 1.1em;
	}
	
	.label, .value {
	  color: #AAA;
	  font-size: 0.9em;
	}
	
	/* 不同奖项类型颜色区分 */
	.cash { border-left: 4px solid #4CAF50; }
	.cash1 { border-left: 4px solid #aaff7f; }
	.cash2 { border-left: 4px solid #00557f; }
	.cash3 { border-left: 4px solid #ff5500; }
	.cash4 { border-left: 4px solid #ffaa00; }
	.device { border-left: 4px solid #2196F3; }
	.voucher { border-left: 4px solid #ffff00; }
	.voucher1 { border-left: 4px solid #005500; }
	.voucher2 { border-left: 4px solid #ffaaff; }
	.voucher3 { border-left: 4px solid #000000; }
	.vehicle { border-left: 4px solid #E91E63; }
	.vehicle1 { border-left: 4px solid #aaaa00; }
	.vehicle2 { border-left: 4px solid #55ffff; }
	
	
	/* 规则 */
	.tip-box {
	  background: rgba(255, 255, 255, 0.1);
	  border-radius: 12px;
	  padding: 16px;
	  margin: 20px 0;
	  border: 1px solid rgba(255, 215, 0, 0.2);
	}
	
	.tip-header {
	  display: flex;
	  align-items: center;
	  margin-bottom: 18px;
	}
	
	.tip-icon {
	  font-size: 24px;
	  color: #ff5500;
	  margin-right: 12px;
	}
	
	.tip-title {
	  color: #00aa00;
	  font-size: 1.2em;
	  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
	}
	
	.tip-list {
	  list-style: none;
	  padding: 0;
	}
	
	.tip-item {
	  display: flex;
	  align-items: flex-start;
	  padding: 12px;
	  margin-bottom: 15px;
	  background: rgba(255, 255, 255, 0.05);
	  border-radius: 8px;
	  transition: transform 0.2s ease;
	}
	
	.tip-item:hover {
	  transform: translateX(5px);
	  background: linear-gradient(90deg, rgba(255,215,0,0.1), transparent);
	}
	
	.item-icon {
	  font-size: 20px;
	  color: #aa5500;
	  margin-right: 15px;
	  flex-shrink: 0;
	}
	
	.item-title {
	  color: #00aaff;
	  font-weight: 500;
	  margin-bottom: 4px;
	  font-size: 0.95em;
	}
	
	.item-content p {
	  color: #aaaa7f;
	  margin: 0;
	  font-size: 0.9em;
	  line-height: 1.4;
	}
</style>